const StarFilled = theme => {
  const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  group.setAttribute('transform', 'scale(0.5) translate(23 35)');

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute(
    'd',
    'm22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03z',
  );
  path.setAttribute('fill', theme.palette.success.main);
  path.setAttribute('stroke', 'none'); // No outline

  group.appendChild(path);
  return group;
};

export default StarFilled;
